import React from 'react';
import ReactDOM from 'react-dom/client';
import ChatPage from './pages/chat';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ChatPage />
  </React.StrictMode>
);
